var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4384_30283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 3C16.8745 3 14.2486 3.16533 12.0841 3.64637C9.90068 4.13162 8.08592 4.96 6.68995 6.35597C5.29398 7.75193 4.4656 9.5667 3.98035 11.7501C3.49932 13.9146 3.33398 16.5405 3.33398 19.6667C3.33398 22.7928 3.49932 25.4187 3.98035 27.5832C4.4656 29.7667 5.29398 31.5813 6.68995 32.9773C8.08592 34.3733 9.90068 35.2017 12.0841 35.687C14.2486 36.168 16.8745 36.3333 20.0007 36.3333C23.1268 36.3333 25.7527 36.168 27.9172 35.687C30.1007 35.2017 31.9153 34.3733 33.3113 32.9773C34.7073 31.5813 35.5357 29.7667 36.021 27.5832C36.502 25.4187 36.6673 22.7928 36.6673 19.6667C36.6673 16.5405 36.502 13.9146 36.021 11.7501C35.5357 9.5667 34.7073 7.75193 33.3113 6.35597C31.9153 4.96 30.1007 4.13162 27.9172 3.64637C25.7527 3.16533 23.1268 3 20.0007 3Z",
    fill: "url(#paint0_linear_4384_30283)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4384_30283)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0007 4C16.8974 4 14.3581 4.1654 12.301 4.62255C10.2363 5.08142 8.61713 5.843 7.39706 7.06307C6.17699 8.28314 5.4154 9.90235 4.95654 11.9671C4.49939 14.0241 4.33398 16.5634 4.33398 19.6667C4.33398 22.7699 4.49939 25.3092 4.95653 27.3662L3.98035 27.5832C3.49932 25.4187 3.33398 22.7928 3.33398 19.6667C3.33398 16.5405 3.49932 13.9146 3.98035 11.7501C4.4656 9.5667 5.29398 7.75193 6.68995 6.35597C8.08592 4.96 9.90068 4.13162 12.0841 3.64637C14.2486 3.16533 16.8745 3 20.0007 3C23.1268 3 25.7527 3.16533 27.9172 3.64637L27.7002 4.62255C25.6432 4.1654 23.1039 4 20.0007 4ZM35.0448 11.9671C34.5859 9.90234 33.8243 8.28314 32.6042 7.06308C31.3841 5.843 29.765 5.08142 27.7002 4.62255L27.9172 3.64637C30.1007 4.13162 31.9153 4.96 33.3113 6.35597C34.7073 7.75193 35.5357 9.5667 36.021 11.7501C36.502 13.9146 36.6673 16.5405 36.6673 19.6667C36.6673 22.7928 36.502 25.4187 36.021 27.5832C35.5357 29.7667 34.7073 31.5813 33.3113 32.9773C31.9153 34.3733 30.1007 35.2017 27.9172 35.687C25.7527 36.168 23.1268 36.3333 20.0007 36.3333C16.8745 36.3333 14.2486 36.168 12.0841 35.687C9.90068 35.2017 8.08592 34.3733 6.68995 32.9773C5.29398 31.5813 4.4656 29.7667 3.98035 27.5832L4.95654 27.3662C5.4154 29.431 6.17698 31.0501 7.39707 32.2702C8.61713 33.4903 10.2363 34.2519 12.3011 34.7108C14.3581 35.1679 16.8974 35.3333 20.0007 35.3333C23.1039 35.3333 25.6432 35.1679 27.7002 34.7108C29.765 34.2519 31.3841 33.4903 32.6042 32.2702C33.8243 31.0501 34.5859 29.431 35.0448 27.3662C35.5019 25.3092 35.6673 22.7699 35.6673 19.6667C35.6673 16.5635 35.5019 14.0241 35.0448 11.9671Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4384_30283)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8715 27.1013C26.7925 25.5155 28.6855 21.0514 27.0998 17.1304C25.514 13.2094 21.0499 11.3164 17.1289 12.9021C13.2079 14.4879 11.3148 18.952 12.9006 22.873C14.4864 26.794 18.9505 28.6871 22.8715 27.1013Z",
    fill: "#FFD04B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6204 21.5887C13.6204 17.2791 17.2178 13.6817 21.5274 13.6817C23.0636 13.6817 24.5063 14.1405 25.7298 14.9235C24.3259 13.3416 22.2807 12.3418 19.9981 12.3418C15.7684 12.3418 12.3398 15.7703 12.3398 20C12.3398 22.1708 13.2438 24.1293 14.6955 25.524C14.013 24.3599 13.6181 23.0131 13.6181 21.5887H13.6204Z",
    fill: "#45B29D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6367 20.4277C22.8738 18.9719 21.8859 17.5996 20.4301 17.3625C18.9743 17.1254 17.6019 18.1133 17.3648 19.5691C17.1277 21.0249 18.1157 22.3973 19.5715 22.6344C21.0273 22.8715 22.3996 21.8835 22.6367 20.4277Z",
    fill: "#334D5C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8289 18.0576C22.4086 19.676 21.58 21.8605 19.3431 21.8605C18.6583 21.8605 18.1059 21.655 17.6836 21.3241C18.1447 22.1275 19.0075 22.6708 20.0005 22.6708C21.475 22.6708 22.6711 21.4747 22.6711 20.0001C22.6711 19.2332 22.347 18.5438 21.8289 18.0576Z",
    fill: "#334D5C"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 31C13.935 31 9 26.065 9 20C9 13.935 13.935 9 20 9C26.065 9 31 13.935 31 20C31 26.065 26.065 31 20 31ZM20 10.9402C15.0056 10.9402 10.9402 15.0033 10.9402 20C10.9402 24.9967 15.0033 29.0598 20 29.0598C24.9967 29.0598 29.0598 24.9967 29.0598 20C29.0598 15.0033 24.9944 10.9402 20 10.9402Z",
    fill: "#929292"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4715 14.4141C29.9714 15.7037 30.2476 17.0962 30.2476 18.5433C30.2476 24.9142 24.9313 30.2327 18.5582 30.2327C17.0608 30.2327 15.6228 29.936 14.2988 29.4041C15.9629 30.4153 17.9145 30.9997 20.0008 30.9997C26.0658 30.9997 31.0008 26.0646 31.0008 19.9997C31.0008 17.9613 30.4416 16.053 29.4715 14.4141Z",
    fill: "#6D6D6D"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5414 11.7004C14.5414 12.3783 13.9913 12.9262 13.3156 12.9262C12.64 12.9262 12.0898 12.376 12.0898 11.7004C12.0898 11.0247 12.64 10.4746 13.3156 10.4746C13.9913 10.4746 14.5414 11.0247 14.5414 11.7004Z",
    fill: "#AEA5A4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3455 11.041C14.2908 11.808 13.768 12.5339 12.7774 12.5339C12.6359 12.5339 12.5057 12.5179 12.3848 12.4905C12.6107 12.7553 12.9417 12.9265 13.3138 12.9265C13.9917 12.9265 14.5396 12.3764 14.5396 11.7007C14.5396 11.4587 14.4665 11.2328 14.3455 11.041Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9108 11.7004C27.9108 12.3783 27.3606 12.9262 26.685 12.9262C26.0093 12.9262 25.4592 12.376 25.4592 11.7004C25.4592 11.0247 26.0093 10.4746 26.685 10.4746C27.3606 10.4746 27.9108 11.0247 27.9108 11.7004Z",
    fill: "#AEA5A4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6893 11.002C27.6323 11.7666 27.1096 12.4902 26.1212 12.4902C25.9751 12.4902 25.8404 12.472 25.7149 12.4446C25.9386 12.7368 26.2878 12.9285 26.685 12.9285C27.3629 12.9285 27.9108 12.3784 27.9108 11.7027C27.9108 11.4425 27.8286 11.2028 27.6893 11.0042V11.002Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5414 28.3C14.5414 28.9779 13.9913 29.5258 13.3156 29.5258C12.64 29.5258 12.0898 28.9757 12.0898 28.3C12.0898 27.6243 12.64 27.0742 13.3156 27.0742C13.9913 27.0742 14.5414 27.6243 14.5414 28.3Z",
    fill: "#AEA5A4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.26 27.5303C14.276 28.3566 13.751 29.1943 12.6872 29.1943C12.6074 29.1943 12.532 29.1875 12.459 29.1783C12.6804 29.3929 12.9817 29.5276 13.315 29.5276C13.9929 29.5276 14.5407 28.9775 14.5407 28.3018C14.5407 28.0073 14.4335 27.7426 14.2623 27.5326L14.26 27.5303Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9105 28.3C27.9105 28.9779 27.3604 29.5258 26.6848 29.5258C26.0091 29.5258 25.459 28.9757 25.459 28.3C25.459 27.6243 26.0091 27.0742 26.6848 27.0742C27.3604 27.0742 27.9105 27.6243 27.9105 28.3Z",
    fill: "#AEA5A4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6064 27.498C27.5973 28.3038 27.0723 29.1027 26.0337 29.1027C25.9333 29.1027 25.8374 29.0936 25.7461 29.0776C25.9721 29.347 26.3053 29.525 26.6843 29.525C27.3622 29.525 27.91 28.9749 27.91 28.2993C27.91 27.9911 27.7936 27.7149 27.6064 27.498Z",
    fill: "white",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4384_30283",
    x: 1.33398,
    y: 1,
    width: 37.3333,
    height: 37.3334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_30283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_30283",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4384_30283",
    x: 1.33398,
    y: 1,
    width: 37.3333,
    height: 37.3334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_30283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_30283",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4384_30283",
    x1: 20.0007,
    y1: 3,
    x2: 20.0007,
    y2: 36.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#2B4864"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4384_30283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/Audio.04fb55f9a2cdc2eea557dd84bcbc3eb6.svg";
export { ForwardRef as ReactComponent };